import { Component, computed, inject, input } from '@angular/core'
import { CartState, ProductKey, ProductType, ProductVariant } from '@naturalcycles/shared'
import { CartService } from '@src/app/core/services/cart.service'
import { Page } from '@src/app/shared/typings/enum/pages.js'

@Component({
  selector: 'app-cart-price',
  templateUrl: './cart-price.component.html',
  styleUrls: ['./cart-price.component.scss'],
  standalone: false,
})
export class CartPriceComponent {
  private cartService = inject(CartService)
  protected Page = Page
  protected page = input<Page>()
  protected cart = input.required<CartState>()
  protected hasShopItems = computed(() => this.cart()?.items.some(i => i.type === ProductType.SHOP))
  protected showOuraDiscountBanner = computed(
    () => this.page() === Page.payment && this.wantsOuraDevice(),
  )

  protected wantsOuraDevice = computed(() =>
    this.cart().items.some(
      i => i.key === ProductKey.OURA_RING_DISCOUNT && i.variant === ProductVariant.wantsDevice,
    ),
  )

  protected netTotal = computed(() => {
    return this.cartService.getCartNetTotal(this.cart())
  })

  protected taxTotal = computed(() => {
    return this.cartService.getCartTaxTotal(this.cart())
  })
}
